import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {NavigationEvent} from '@spartacus/storefront';
import {isPlatformBrowser} from '@angular/common';
import {Observable} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map} from 'rxjs/operators';
import {CategoryPageEvent} from './category-page-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CategoryPageEventService {
  constructor(@Inject(PLATFORM_ID) public platformId: string, protected event: EventService) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.event.register(CategoryPageEvent, this.buildCategoryPageEvent());
  }

  protected buildCategoryPageEvent(): Observable<CategoryPageEvent> {
    return this.event.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => navigationEvent.context?.id.startsWith('/categories')),
      map((navigationEvent) => {
        navigationEvent.semanticRoute = 'categories';
        return navigationEvent;
      }),
      map((navigationEvent) =>
        createFrom(CategoryPageEvent, {
          navigation: navigationEvent,
        })
      )
    );
  }
}
